import { IconType } from "./icons.types";

export const ViewIcon = ({ className, color = "#202224" }: IconType) => {
  return (
    <svg
      width="19"
      height="20"
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g opacity="0.6">
        <path
          d="M16.7282 8.30029C17.6462 9.26618 17.6462 10.7337 16.7282 11.6995C15.1799 13.3286 12.5207 15.5416 9.50004 15.5416C6.47942 15.5416 3.82022 13.3286 2.27189 11.6995C1.35387 10.7337 1.35387 9.26618 2.27189 8.30029C3.82022 6.67122 6.47942 4.45825 9.50004 4.45825C12.5207 4.45825 15.1799 6.67122 16.7282 8.30029Z"
          stroke={color}
        />
        <path
          d="M11.875 9.99992C11.875 11.3116 10.8117 12.3749 9.50004 12.3749C8.18836 12.3749 7.12504 11.3116 7.12504 9.99992C7.12504 8.68824 8.18836 7.62492 9.50004 7.62492C10.8117 7.62492 11.875 8.68824 11.875 9.99992Z"
          stroke={color}
        />
      </g>
    </svg>
  );
};
